import React, { useContext, useState } from "react";
import { ScrollView, StyleSheet, Text, View } from "react-native";
import SessionContext from "../../../../contexts/session";
import ExistingIntegrationsSection from "./ExistingIntegrationsSection";
import TOKENS from "./styles/tokens";
import IntegrationWizard from "./wizard/IntegrationWizard";

const IntegrationsV2Page: React.FC = () => {
  const sessionContext = useContext(SessionContext);
  const session = sessionContext?.session;
  const [integrationsRefreshKey, setIntegrationsRefreshKey] = useState(0);

  return (
    <ScrollView style={styles.page} contentContainerStyle={styles.content}>
      <View style={styles.headerRow}>
        <View style={styles.headerTextBlock}>
          <Text style={styles.title}>Integrations V2</Text>
          <Text style={styles.subtitle}>
            Unified setup wizard with backend schema-driven configuration.
          </Text>
        </View>
      </View>

      {!session ? (
        <View style={styles.noticeCard}>
          <Text style={styles.noticeTitle}>Sign in required</Text>
          <Text style={styles.noticeText}>
            Please sign in to manage clinic integrations.
          </Text>
        </View>
      ) : (
        <>
          <ExistingIntegrationsSection
            session={session}
            refreshKey={integrationsRefreshKey}
          />
          <IntegrationWizard
            session={session}
            onIntegrationCreated={() =>
              setIntegrationsRefreshKey((current) => current + 1)
            }
          />
        </>
      )}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  page: {
    flex: 1,
    backgroundColor: TOKENS.color.background,
  },
  content: {
    padding: TOKENS.spacing.lg,
    gap: TOKENS.spacing.md,
  },
  headerRow: {
    gap: TOKENS.spacing.sm,
  },
  headerTextBlock: {
    gap: TOKENS.spacing.xs,
  },
  title: {
    fontFamily: TOKENS.font.bold,
    fontSize: TOKENS.fontSize.xxl,
    lineHeight: TOKENS.lineHeight.xl,
    color: TOKENS.color.textPrimary,
  },
  subtitle: {
    fontFamily: TOKENS.font.regular,
    fontSize: TOKENS.fontSize.md,
    lineHeight: TOKENS.lineHeight.md,
    color: TOKENS.color.textSecondary,
  },
  noticeCard: {
    borderWidth: 1,
    borderColor: TOKENS.color.border,
    borderRadius: TOKENS.radius.lg,
    backgroundColor: TOKENS.color.surface,
    padding: TOKENS.spacing.lg,
    gap: TOKENS.spacing.xs,
  },
  noticeTitle: {
    fontFamily: TOKENS.font.semibold,
    fontSize: TOKENS.fontSize.lg,
    color: TOKENS.color.textPrimary,
  },
  noticeText: {
    fontFamily: TOKENS.font.regular,
    fontSize: TOKENS.fontSize.sm,
    lineHeight: TOKENS.lineHeight.sm,
    color: TOKENS.color.textSecondary,
  },
});

export default IntegrationsV2Page;
